
import React from 'react';
import * as yup from 'yup';
import { useDispatch, useSelector } from "react-redux";
import "./../Custom.css";
import { objectToFormData, findLodash } from '../../../../utils';
import { addMerchantsField, updateMerchantsField } from '../../../../actions/companySettings';
import { Input, Form, Button } from 'antd';

//  const { Option } = Select;
const { TextArea } = Input;

const ValidationSchema = yup.object().shape({
  name: yup
    .string()
    .required('Please provide category name'),
  code: yup.string(),
  description: yup.string(),
});

const AddMerchantsField = (props) => {
  const { id: currentId,
    // employeesData = [],
  } = props;
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const merchantsFieldResponse = useSelector(state => state.companySetting.getMerchantsField || {});
  // const addMerchantsFieldResponse = useSelector(state => state.companySetting.addMerchantsField || {});

  React.useEffect(() => {
    form.resetFields();
    if (merchantsFieldResponse.success && currentId) {
      const editValues = findLodash(merchantsFieldResponse.data.response.transaction_merchants, { id: currentId }) || {};
      form.setFieldsValue({
        name: editValues.name,
        code: editValues.code,
        description: editValues.description,
        is_enable: editValues.is_enable
        // user_id: editValues.user_id,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  const handleSubmit = (values) => {
    const payload = {};
    [
      'code',
      'name',
      'description',
      'is_enable'
    ].forEach(item => {
      payload[item] = values[item] || false;
    });

    payload.enable = true;

    ValidationSchema.validate(payload)
      .then(function ({ ...value }) {
        form.resetFields();
        Object.keys(payload).forEach(key => {
          if (!payload[key] && key !== "is_enable") {
            delete payload[key];
          }
        });
        currentId ?
          dispatch(updateMerchantsField(objectToFormData({ ...payload, id: currentId.toString() }))) :
          dispatch(addMerchantsField(objectToFormData({ ...payload })));
      })
      .catch(function (err) {
      });
  }

  const handleCancelButton = () => {
    form.resetFields();
    props.handleCancel();
  }

  return (
    <>
      <Form
        layout="vertical"
        form={form}
        onFinish={handleSubmit}
        className="modal-form custom-form small-width"
      >
        <Form.Item label="Merchant Name" name="name" rules={[{ required: true, message: 'Please enter name' }]}>
          <Input placeholder="Enter Merchant Name" maxLength={50} />
        </Form.Item>
        <Form.Item label="Merchant Code" name="code">
          <Input placeholder="Enter Merchant Code" />
        </Form.Item>
        {/* <Form.Item name="user_id" label="Merchant Head">
              <Select
                  placeholder="Select Merchant Head"
              >
                {employeesData && employeesData.map(({ user_id, name }) => <Option key={user_id} value={user_id}>{name}</Option>)}
              </Select>
          </Form.Item> */}
        <Form.Item label="Description" name="description">
          <TextArea
            placeholder="Enter Description"
            autoSize={{ minRows: 3, maxRows: 5 }}
          />
        </Form.Item>

        <Button key="1" htmlType="submit" className="formButton mt1">{currentId ? 'Update' : 'Save'}</Button>
        <Button key="2" className="cancelButton ml1 mt1" onClick={() => handleCancelButton()}>Cancel</Button>
      </Form>
    </>
  );
}

export default AddMerchantsField;

